module.exports = __webpack_public_path__ + "img/haut-und-haarpflege_kachel_MICROSILVER.a96ccdf4.png";